import modals from "../views/modals";
import SoundsUtil from './sounds';

const open = target => {
    SoundsUtil.click();

    const overlay = document.querySelector('.modal-overlay');

    // Открываем овейлер
    if(overlay.style.display === 'none')
        overlay.style.display = 'flex';

    // Находим модально окно
    const modals_active = document.querySelectorAll('.modal');
    
    let has_opened = false;

    for(let i = 0; i < modals_active.length; i++)
        if(modals_active[i].style.display !== 'none') {
            has_opened = true;

            modals_active[i].classList.remove('animate__zoomIn');
            modals_active[i].classList.add('animate__zoomOut');
        }

    if(has_opened) {
        setTimeout(() => {
            const modals_closed = document.querySelectorAll('.modal.animate__zoomOut');

            for(let i = 0; i < modals_closed.length; i++) {
                modals_closed[i].style.display = 'none';
                modals_closed[i].classList.remove('animate__zoomOut');
                modals_closed[i].classList.add('animate__zoomIn');
            }

            const modal = document.querySelector(`div[data-target="${target}"]`);

            if(modal)
                modal.style.display = 'block';
        }, 500);
    } else {
        const modal = document.querySelector(`div[data-target="${target}"]`);

        if(modal)
            modal.style.display = 'block';
    }
}

const close = () => {
    SoundsUtil.click();

    const overlay = document.querySelector('.modal-overlay');

    // закрываем овейлер
    if(overlay) {
        overlay.classList.remove('animate__fadeIn');
        overlay.classList.add('animate__fadeOut');
    }

    // Находим модально окно
    const modals_active = document.querySelectorAll('.modal');

    for(let i = 0; i < modals_active.length; i++)
        if(modals_active[i].style.display !== 'none') {
            modals_active[i].classList.remove('animate__zoomIn');
            modals_active[i].classList.add('animate__zoomOut');
        }

    setTimeout(() => {
        const modals_closed = document.querySelectorAll('.modal.animate__zoomOut');

        for(let i = 0; i < modals_closed.length; i++) {
            modals_closed[i].style.display = 'none';
            modals_closed[i].classList.remove('animate__zoomOut');
            modals_closed[i].classList.add('animate__zoomIn');
        }

        overlay.style.display = 'none';
        overlay.classList.remove('animate__fadeOut');
        overlay.classList.add('animate__fadeIn');
    }, 500);
}

const showGame = () => {
    const game = document.querySelector('.game-scene');

    if(!game)
        return;

    SoundsUtil.gameClick();
    SoundsUtil.gameOpen();

    if(game.classList.contains('animate__fadeOut')) {
        game.classList.remove('animate__fadeOut');
        game.classList.add('animate__fadeIn');
    }

    game.style.display = 'flex';
}

const hideGame = () => {
    SoundsUtil.gameClick();
    SoundsUtil.gameClose();

    const game = document.querySelector('.game-scene');

    if(!game)
        return;

    if(game.classList.contains('animate__fadeIn')) {
        game.classList.remove('animate__fadeIn');
        game.classList.add('animate__fadeOut');
    }
    
    setTimeout(() => {
        game.style.display = 'none';
    }, 500);
}

export default {
    open,
    close,
    showGame,
    hideGame
}